module.exports = __webpack_public_path__ + "static/media/Child.85bd5ee1.png";